<div class="ap-otp" (paste)="onPaste($event)">
  <input
    *ngFor="let i of slots"
    #digit
    type="tel"
    inputmode="numeric"
    maxlength="1"
    autocomplete="off"
    [attr.aria-label]="'Digit ' + (i + 1) + ' of 6'"
    (input)="onInput(i, $event)"
    (keydown)="onKeydown(i, $event)"
  />
</div>
